import { computed, makeObservable } from 'mobx'
import { GetCurrentUserWorkspaceMemberships } from 'iam/WorkspaceMembershipStore'

/**
 * View model for scoping jobs.
 */
export default class OCRScopingJobsPermissionViewModel {
  constructor(
    private getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMemberships,
  ) {
    makeObservable(this)
  }

  @computed
  get canViewScopingJobs() {
    return Boolean(
      this.getCurrentUserWorkspaceMemberships().some(
        (wsm) =>
          wsm.member.hasPermission('SCOPE_WORK') &&
          wsm.member.hasPermission('ADMIN_SCOPE_WORK_VIEW'),
      ),
    )
  }

  @computed
  get canManageOCRScopingJobs() {
    return this.getCurrentUserWorkspaceMemberships().some((wms) =>
      wms.member.hasPermission('ADMIN_MANAGE_OCR_JOBS'),
    )
  }
}
